import React, { useState } from 'react';
import Routes from '../../routes';
import SearchResult from '../SearchResult';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import { withRouter } from 'react-router';
import { isDesktop, isMobile, trakrefFontFamily } from '../../utils';
import { Grey3 } from '../../color_utils';
import './Search.css';
import useSearch from '../../context/Search/SearchContext';
import { Box } from '@mui/material';
const initialState = {
    workOrders: { data: [], isSearchById: false },
    assets: { data: [], isSearchById: false },
    locations: { data: [], isSearchById: false },
    serviceEvents: { data: [], isSearchById: false }
};

const Search = ({
    push,
    inputRef,
    onBlur,
    onSearchFocus,
    disabled,
}) => {
    const [properties, setProperties] = useState({
        ...initialState,
        allowNew: false,    
        open: false,
        isLoading: true,
        multiple: false,
        keyword: null,
        options: []
    });
    const { state, dispatch } = useSearch();
    const [debounceTimer, setDebounceTimer] = useState(null);

    const handleInputChange = (e) => {
        const value = e.target.value;

            dispatch({ type: "SET_QUERY", payload: value });

            // Debounce redirect
            if (debounceTimer) clearTimeout(debounceTimer);
            setDebounceTimer(
                setTimeout(() => {
                    if (value.length < 3) return;
                    const searchResultsUrl = "/SearchResults";
                    if (window.location.pathname !== searchResultsUrl) {
                        push(searchResultsUrl);
                    }
                }, 1000)
            );
    };

    const search = (query) => {

        setProperties(prevProperties => ({
            ...prevProperties,
            ...initialState,
            keyword: query, 
            open: true,
            isLoading: true,
        }));

        setProperties(prevProperties => ({ ...prevProperties, keyword: query, open: true }));

        const device = isMobile ? 'mobile' : isTablet ? 'tablet' : 'desktop';
        fetch(Routes.Dashboard.Search(device), {
            method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(query)
        })
        .then(response => response.json())
        .then(json => {
            // console.log(json);
            const newState = {
                isLoading: false,
                keyword: query,
                options: json,
                workOrders: processSearchData(json.filter((obj) => obj.link.includes("WorkOrder")), "woNumber", query),
                assets: processSearchData(json.filter((obj) => obj.link.includes("Inventory")), "woNumber", query),
                locations: processSearchData(json.filter((obj) => obj.link.includes("Location")), "locationName", query),
                serviceEvents: processSearchData(json.filter((obj) => obj.link.includes("ServiceEvent")), "text", query),
            };
            return setProperties(newState);
        })
        .catch(err => console.log('Error fetching options', err));
    };

    const setOpen = () => setProperties(prevProperties => ({ ...prevProperties, open: false }));

    const onClick = (route) => {
        push(route);
        return setOpen();
    };

    const highlightKeyword = (item, searchTerm) => {
        if (!searchTerm) return item;
        // Create a case-insensitive regex for the keyword.
        const regex = new RegExp(`(${searchTerm})`, 'gi');
        const parts = item.split(regex);
        
        const text = parts.map((part, index) => {
            if (part.toLowerCase() === searchTerm.toLowerCase()) {
                return (
                    <span key={index} style={{ backgroundColor: 'yellow' }}>
                        {part}
                    </span>
                );
            }

            return (
                <span key={index}>
                    {part}
                </span>
            );
        });

        // return { text, count };
        return text;
    };

    const getCount = (data, key) => {
        return data.reduce((accumulator, currentValue) => accumulator + currentValue[key].count, 0);
    };

    const mapSearchData = ({
        items,
        titleKey,
        subTitleKey,
        isIdAtSubtitle = false,
        searchTerm = "",
    }) => {
        const data = items.map((item) => {
            const title = highlightKeyword(item[titleKey], searchTerm);
            const subTitle = highlightKeyword(subTitleKey(item), searchTerm);
            const link = item.link;
            return { title, subTitle, link };
        });
        const titleCount = getCount(data, 'title');
        const subTitleCount = getCount(data, 'subTitle');
        const isSearchById = subTitleCount > titleCount;
        const isOrCondition = subTitleCount > 0 && titleCount > 0;

        return { 
            data, 
            isSearchById: isIdAtSubtitle ? !isSearchById : isSearchById,
            isOrCondition
        };
    };

    const processSearchData = (data, key, searchTerm) => {
        return mapSearchData({
            items: data,
            titleKey: key,
            // \u2022 = bullet character (•)
            subTitleKey: (item) => `${item.locationName} \u2022 ${item.status} \u2022 ${item.text.substr(1, item.text.length - 1)}`,
            searchTerm
        });
    };

    return (
        <div className="search-bar-style flex" tabIndex="0">
            <AsyncTypeahead
                delay={1000}
                id="MainSearchBar"
                isLoading={properties.isLoading}
                className="MainSearchBar"
                style={{ width: "100%" }}
                labelKey="text"
                minLength={3}
                onSearch={search}
                useCache={false}
                open={properties.open}
                disabled={disabled}
                placeholder={
                    isDesktop ? "Search for Work Orders, Locations, Service Events, or Inventory"
                        : isMobile
                            ? "Search..."
                            : "Search for Work Orders, Service Events, and more..."
                }
                inputProps={{
                    autoComplete: "off",
                    style: {
                        height: '100%',
                        width: '100%',
                        outlineColor: '#008299',
                        borderColor: '#008299',
                        border: 'none',
                        borderRadius: '5px',
                        fontSize: '14px',
                    },
                }}
                clearButton={true}
                renderInput={(inputProps) => (
                    <Box
                        sx={{
                            height: { xs: '40px', md: '50px' },
                            width: { xs: '100%', lg: '80%' },
                            position: 'relative',
                            display: 'flex',
                            alignItems: 'center',
                            margin: { lg: '0 auto' },
                        }}
                    >
                        <input
                            {...inputProps}
                            value={
                             state.query
                            }
                            onChange={(e) => {
                                handleInputChange(e);
                            }}
                            onFocus={onSearchFocus}
                            onBlur={onBlur}
                            ref={inputRef}
                            disabled={disabled}
                        />
                        {inputProps.value && (
                            <button
                                type="button"
                                onClick={(events) => {
                                    if (isDesktop === false) {
                                        dispatch({ type: "CLEAR_QUERY" });
                                        return;
                                    }
                                    events.persist = () => {}
                                    events.target.value = '';
                                    inputProps.onChange(events);
                                }}
                                style={{
                                    position: 'absolute',
                                    right: '5px',
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    color: Grey3,
                                    textAlign: 'right',
                                    fontFamily: trakrefFontFamily,
                                    fontSize: '12px',
                                    fontStyle: 'normal',
                                    fontWeight: '600',
                                    lineHeight: 'normal',
                                }}
                                value='sad'
                                aria-label="Clear"
                            >
                                Clear search
                            </button>
                        )}
                    </Box>
                )}
            />
        </div>
    );
};

const SearchWithRouter = withRouter(Search);

export default SearchWithRouter;
